import React, { useState, useEffect } from 'react';
import { Alert, AlertTitle, Button, Box, Collapse } from '@mui/material';
import api from '../services/api';

interface Disclosure {
  id: number;
  type: string;
  title: string;
  content: string;
  needs_acknowledgment: boolean;
}

const DisclosureBanner: React.FC = () => {
  const [disclosures, setDisclosures] = useState<Disclosure[]>([]);

  useEffect(() => {
    const fetchDisclosures = async () => {
      try {
        const res = await api.get('/api/v1/disclosures/active');
        const pending = (res.data || []).filter((d: Disclosure) => d.needs_acknowledgment);
        setDisclosures(pending);
      } catch {
        // Silently fail — banner is non-critical
      }
    };
    fetchDisclosures();
  }, []);

  const handleAcknowledge = async (id: number) => {
    try {
      await api.post(`/api/v1/disclosures/${id}/acknowledge`);
      setDisclosures((prev) => prev.filter((d) => d.id !== id));
    } catch {
      // Silently fail
    }
  };

  if (disclosures.length === 0) return null;

  return (
    <Box sx={{ mb: 2 }}>
      {disclosures.map((d) => (
        <Collapse key={d.id} in={true}>
          <Alert
            severity="info"
            sx={{ mb: 1, border: '1px solid rgba(58,140,140,0.3)' }}
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => handleAcknowledge(d.id)}
              >
                I Understand
              </Button>
            }
          >
            <AlertTitle>{d.title}</AlertTitle>
            {d.content}
          </Alert>
        </Collapse>
      ))}
    </Box>
  );
};

export default DisclosureBanner;
